module.exports = __webpack_public_path__ + "media/images/logos/logo-services-922befb0c45761044a5bcff29c657290.svg";